import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { TEACHERS_BY_LOCATION_READ, REGION_LOCATION_METRICS_READ } from "../const/EprOverviewConst";

/**
 * Data Access for the EPR Overview Service
 * @name EprOverviewDao
 * @param props
 * @return {null|*}
 */
const EprOverviewDao = (props) => {
    const { action, locationKey, locationKeys, schoolYearKey, token } = props;

    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        }
    };

    switch (action) {
        case "teachersByLocationRead":
            options.method = "GET";
            options.url = `${TEACHERS_BY_LOCATION_READ}${locationKey}/details.json`;
            if (schoolYearKey != null) {
                options.params = { schoolYearKey };
            }
            break;
        case "regionLocationMetricsRead":
            options.method = "GET";
            options.url = REGION_LOCATION_METRICS_READ;
            options.params = { locationKeys };
            if (schoolYearKey != null) {
                options.params.schoolYearKey = schoolYearKey;
            }
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

EprOverviewDao.propTypes = {
    action: PropTypes.string.isRequired,
    locationKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    locationKeys: PropTypes.string,
    schoolYearKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    token: PropTypes.string.isRequired
};

export default EprOverviewDao;
